import { CreatorMode, EditorMode } from "../../types/editorModeEnum";
import EditorList from "./EditorList";
import './Editor.scss';
import Creator from "./creator/Creator";
import { RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { setCreatorMode, setEditorMode } from "../../store/editorSlice";
import { useEffect } from "react";

function Editor() {
    const dispatch = useDispatch();
    const { editorMode } = useSelector((state: RootState) => state.editor);
    

    useEffect(() => {
        //TMP FOR DEVELOPMENT
        //dispatch(setEditorMode(EditorMode.Edit));
        //dispatch(setCreatorMode(CreatorMode.SetupSingleRoleRow));
    }, [])

    switch (editorMode) {
        case EditorMode.Create:
        case EditorMode.Edit:
            return <Creator />
        case EditorMode.List:
        default:
            return <EditorList />
    }
}

export default Editor;